/** Shared width for the one right-hand slot (#2074). */
export const RIGHT_SLOT = {
  minWidth: 280,
  maxWidth: 550,
  defaultWidth: 360,
  /** The main pane stays at least this wide while the slot is open. */
  mainFloor: 400,
};

/**
 * Clamp the slot so the main pane keeps `mainFloor` pixels.
 * The slot shrinks before the main pane does. A window that cannot
 * hold the preferred minimum still keeps the floor, and the slot
 * becomes whatever space is left.
 */
export function clampRightSlotWidth(width, viewport, sidebarWidth) {
  const view = Number(viewport) || 0;
  const sidebar = Number(sidebarWidth) || 0;
  const room = Math.max(0, view - sidebar - RIGHT_SLOT.mainFloor);
  const max = Math.min(RIGHT_SLOT.maxWidth, room);
  const min = Math.min(RIGHT_SLOT.minWidth, max);
  const numeric = Number(width);
  const base = Number.isFinite(numeric) ? numeric : RIGHT_SLOT.defaultWidth;
  if (max <= 0) return 0;
  return Math.round(Math.min(max, Math.max(min, base)));
}
